/* eslint-disable */

import * as runtime from '../runtime';
import type {
  CreateGiftCardPurchaseIntentDto,
  GiftCardPurchaseIntentResponseDto,
  ResultDto,
} from '../models';

export interface CreatePurchaseIntentRequest {
  createGiftCardPurchaseIntentDto: CreateGiftCardPurchaseIntentDto;
}

export interface InAppCompleteGiftCardRequest {
  id: string;
  sendToRecipient: string;
  invoiceId: string;
}

export class GiftCardsApi extends runtime.BaseAPI {

  async createPurchaseIntent(requestParameters: CreatePurchaseIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GiftCardPurchaseIntentResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: '/gift-cards/purchase-intent',
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createGiftCardPurchaseIntentDto,
    }, initOverrides);
    return response.json();
  }

  async inAppCompleteGiftCard(requestParameters: InAppCompleteGiftCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultDto> {
    const queryParameters: any = {};

    if (requestParameters.sendToRecipient !== undefined) {
      queryParameters['sendToRecipient'] = requestParameters.sendToRecipient;
    }

    if (requestParameters.invoiceId !== undefined) {
      queryParameters['invoiceId'] = requestParameters.invoiceId;
    }

    const response = await this.request({
      path: `/gift-cards/${encodeURIComponent(String(requestParameters.id))}/in-app-complete`,
      method: 'POST',
      headers: {},
      query: queryParameters,
    }, initOverrides);
    return response.json();
  }

}
